module.exports = __webpack_public_path__ + "media/logos/321_sprzedane_1-0a981951.svg";